import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Stack, Box, Button, Typography, Title} from 'views/components';
import {Edit as EditIcon} from 'views/icons';
import {Translate} from 'views/module';

import AddWidgetModal from '../../AddWidgetModal';
import ConfirmResetModal from './ConfirmResetModal';
import EditButtons from './EditButtons';

const PersonalHeader = (props) => {
  const [showAddWidgetModal, setShowAddWidgetModal] = React.useState(false);
  const [showResetConfirmModal, setShowResetConfirmModal] = React.useState(false);
  const {
    editMode,
    setEditMode,
    onSaveLayout,
    onCancelLayout,
    onResetLayout,
    addWidget,
    settings,
    user,
  } = props;

  const saveModal = (widgetType) => {
    addWidget(widgetType);
    setShowAddWidgetModal(false);
  };

  const confirmReset = () => {
    onResetLayout();
    setShowResetConfirmModal(false);
  };

  return (
    <Stack
      direction={{md: 'row', xs: 'column'}}
      justifyContent="space-between"
      spacing={{xs: 2}}
    >
      {
        showAddWidgetModal &&
        <AddWidgetModal
          saveModal={saveModal}
          closeModal={() => setShowAddWidgetModal(false)}
          settings={settings}
        />
      }
      {
        showResetConfirmModal &&
        <ConfirmResetModal
          closeModal={() => setShowResetConfirmModal(false)}
          onClickConfirm={confirmReset}
        />
      }
      {
        editMode &&
          <>
            <Box>
              <Button variant='outlined' color="warning">
                <Typography sx={{textTransform: 'uppercase', fontWeight: 500}}>
                  <Translate expression='dashboard.Customization.EditMode'/>
                </Typography>
              </Button>
            </Box>
            <Box>
              <EditButtons
                onAddWidget={() => setShowAddWidgetModal(true)}
                onReset={() => setShowResetConfirmModal(true)}
                onCancel={onCancelLayout}
                onSave={onSaveLayout}
              />
            </Box>
          </>
      }
      {
        !editMode &&
          <>
            <Box>
              <Title disableDivider sx={{fontWeight: 600, display: 'inline-block'}}>
                <Translate expression='dashboard.Welcome'/>  {user.firstName} {user.lastName}
              </Title>
            </Box>
            <Box>
              <Button variant='outlined' onClick={() => setEditMode(true)}>
                <EditIcon />
                <Typography sx={{textTransform: 'uppercase', fontWeight: 500, pl: 1, color: 'black'}}>
                  <Translate expression='dashboard.Customization.CustomizeDashboard'/>
                </Typography>
              </Button>
            </Box>
          </>
      }
    </Stack>
  );
};

PersonalHeader.propTypes = {
  user: PropTypes.object.isRequired,
  editMode: PropTypes.bool.isRequired,
  setEditMode: PropTypes.func.isRequired,
  onSaveLayout: PropTypes.func.isRequired,
  onCancelLayout: PropTypes.func.isRequired,
  onResetLayout: PropTypes.func.isRequired,
  addWidget: PropTypes.func.isRequired,
  settings: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps, dispatch)(PersonalHeader);
